rkcApp.factory('hasAccessTo', ['userService',function(userService){
    return {
        orders: ()=> {return["admin", "order-recorder", "order-admin"].some((auth)=>userService.userDetails.authorities.includes(auth))},
        orderConfirmation:()=>{return ["admin", "order-admin"].some((auth)=>userService.userDetails.authorities.includes(auth))},
        prognosis:()=> {return ["admin", "prognosis-user"].some((auth)=>userService.userDetails.authorities.includes(auth))},
        expedition:()=> {return ["admin", "expedition"].some((auth)=>userService.userDetails.authorities.includes(auth))},
        administrate: ()=>{return userService.userDetails.authorities.includes("admin")}
    }
}]);


/** WEBPACK FOOTER **
 ** ./src/app/services/authAccessService.ts
 **/